export function createMailUrl(mailToUrlParams) {
    const { from, subject, body } = mailToUrlParams;
    return `mailto:?from=${from}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
